/**
 * Searching the practice's colleagues (the contacts kept in Settings > MedicAI Network) to fill in
 * a patient's medical team.
 */

const lower = (value: any): string => (value === null || value === undefined ? '' : String(value)).toLowerCase().trim();

const sameDoctor = (a: any, b: any): boolean =>
  (!!lower(a.email) && lower(a.email) === lower(b.email))
  || (lower(a.name) === lower(b.name) && lower(a.surname) === lower(b.surname));

/**
 * Active colleagues matching every word of the query (name, surname, speciality, email or practice
 * number), without those already on the team, A to Z by surname.
 */
export function searchColleagues(colleagues: any[], query: string, team: any[] = [], limit = 8): any[] {
  const words = lower(query).split(/\s+/).filter(Boolean);
  return (colleagues || [])
    .filter(c => c && c.active !== false && c.name && c.surname)
    .filter(c => !team.some(member => sameDoctor(member, c)))
    .filter(c => {
      const haystack = [c.title, c.name, c.surname, c.speciality, c.email, c.practiceNumber].map(lower).join(' ');
      return words.every(word => haystack.includes(word));
    })
    .sort((a, b) => lower(a.surname).localeCompare(lower(b.surname)) || lower(a.name).localeCompare(lower(b.name)))
    .slice(0, limit);
}

/** A colleague as a medical team entry; the team keeps the colleague's contact number as `phone`. */
export function colleagueToTeamMember(colleague: any): any {
  return {
    title: colleague.title || '',
    name: colleague.name || '',
    surname: colleague.surname || '',
    speciality: colleague.speciality || '',
    practiceNumber: colleague.practiceNumber || '',
    email: colleague.email || '',
    phone: colleague.contactNumber || '',
  };
}
